import { render, staticRenderFns } from "./notice_detail.vue?vue&type=template&id=306ddc62&scoped=true&"
import script from "./notice_detail.vue?vue&type=script&lang=js&"
export * from "./notice_detail.vue?vue&type=script&lang=js&"
import style0 from "./notice_detail.vue?vue&type=style&index=0&id=306ddc62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306ddc62",
  null
  
)

export default component.exports